import type React from 'react';
import { useIntl } from 'react-intl';

import { useHost } from '@xing-com/crate-xinglet';

import { TrackingLink } from '../../../../tracking-link';

import {
  StyledAnchor,
  StyledCard,
  StyledIconWrapper,
  StyledHeadline,
  StyledBodyCopy,
} from './inspirational-card.styles';

type InspirationalCard = {
  icon: React.FC<React.SVGProps<SVGSVGElement>>;
  title: string;
  description: string;
  link: string;
  backgroundColor: string;
  textColor: string;
  trackingParam?: Record<string, string>;
};

export const InspirationalCard: React.FC<InspirationalCard> = ({
  icon: Icon,
  title,
  description,
  link,
  backgroundColor,
  textColor,
  trackingParam,
}) => {
  const { formatMessage } = useIntl();
  const { isPreview } = useHost();

  const finalLink =
    link === 'https://login.xing.com/'
      ? isPreview
        ? 'https://login.preview.xing.com'
        : 'https://login.xing.com/'
      : link;

  return (
    <TrackingLink
      as={StyledAnchor}
      url={finalLink}
      trackingParams={trackingParam || {}}
    >
      <StyledCard backgroundColor={backgroundColor}>
        <StyledIconWrapper backgroundColor={textColor}>
          <Icon height={32} width={32} />
        </StyledIconWrapper>
        <StyledHeadline
          size="xxlarge"
          sizeConfined="xlarge"
          textColor={textColor}
        >
          {formatMessage({ id: title })}
        </StyledHeadline>
        <StyledBodyCopy
          size="large"
          sizeConfined="medium"
          textColor={textColor}
          noMargin
        >
          {formatMessage({ id: description })}
        </StyledBodyCopy>
      </StyledCard>
    </TrackingLink>
  );
};
